const initUser = {
	id: '',
	contactId: '',
	firstName: '',
	lastName: '',
	companies: [],
	image: { file: '', name: '', preview: '' },
	emailWork: '',
	emailPersonal: '',
	emailOther: '',
	contactTypes: [{ Id: '2', Title: 'Alternate' }],
	phoneWork: { number: '', dialCode: '', countryCode: '', ext: '' },
	phoneMobile: { number: '', dialCode: '', countryCode: '', ext: '' },
	phoneOther: { number: '', dialCode: '', countryCode: '', ext: '' },
	note: '',
	addressWork: {
		address_id: '',
		type: '',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		placeId: '',
		coordinate: { lat: '', lng: '' },
		unit: '',
		fullAddress: '',
	},
	addressHome: {
		address_id: '',
		type: '',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		placeId: '',
		coordinate: { lat: '', lng: '' },
		unit: '',
		fullAddress: '',
	},
	addressOther: {
		address_id: '',
		type: '',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		placeId: '',
		coordinate: { lat: '', lng: '' },
		unit: '',
		fullAddress: '',
	},
	languages: [{ id: '1', code: 'en', name: 'English' }],
	username: '',
	pwd: '',
	confirmPwd: '',
	isEnabled: true,
	mstCustId: '',
	accessOptions: [],
	roles: [],
	apps: [],
	postLoginAppId: '',
};

export default initUser;
